import assert from 'assert-ts';
import {StyleSheet, css, CSSProperties} from '../../../styleSheet';
import {getStylePropertiesFromCategoriesAndCustomStyle} from '../functions';

import {StyleCategoryName, BaseAllCategoryProps} from '../types';

const cssCache: {[key: string]: string} = {};

export const useStyleCategories = (
  categories: StyleCategoryName[],
  props: BaseAllCategoryProps,
  customStyle: CSSProperties,
): string => {
  const styles = getStylePropertiesFromCategoriesAndCustomStyle(
    categories,
    props,
    customStyle,
  );
  const stylesheet = styles ? StyleSheet.create({di: styles}) : undefined;
  const key = stylesheet ? JSON.stringify(stylesheet) : 'undefined';
  if (!cssCache[key]) {
    try {
      cssCache[key] = stylesheet ? css(stylesheet.di) : '';
    } catch (error) {
      assert.soft(false, 'useStyleCategories:generate css failed":', {
        styles,
      });

      cssCache[key] = '';
    }
  }

  return cssCache[key];
};
